export function currency(value: number): string {
  const DIGITS = 2;
  return value.toFixed(DIGITS) + ' ₽';
}
